import Chat from '../views/Chat';

export default function ChatPage({ user }) {
  return (
      <Chat user={user} />
  );
}